import React from "react";
import { ActionHandlerFunction, DeviceCertificate } from "@preveil-api";
import { AdminUIActionTypes, useAppSelector } from "src/common";
import { Icon, ToolbarWrapper, ToolbarFilter, ToolbarButton } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  is_loading: boolean;
  certificates: DeviceCertificate[];
  filtered_certificates: DeviceCertificate[];
  handleAction: ActionHandlerFunction;
  filter_param?: string;
}

function ToolbarComponent(props: AllProps) {
  const { is_loading, certificates, filtered_certificates, filter_param, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);

  return <ToolbarWrapper
    leftContent={<ToolbarFilter
      disabled={certificates.length === 0}
      filter_param={filter_param ?? ""}
      onChange={(value) => handleAction({ actionType: AdminUIActionTypes.SearchParam, params: value })}
      onClick={() => handleAction({ actionType: AdminUIActionTypes.SearchParam })} />}
    refreshAction={() => handleAction({ actionType: AdminUIActionTypes.GetRefreshRequest })}
    refreshTooltipContent="Refresh Devices"
    isLoading={is_loading}
    paginationInfo={certificates.length > 0 ? <span>{`${filtered_certificates.length < certificates.length ? `${filtered_certificates.length} of ` : ""}${certificates.length} ${certificates.length > 1 ? "Certificates" : "Certificate"}`}</span> : undefined}
  >
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
      ariaLabel="Create Device Certificate"
      tooltipContent="Create Device Certificate">
      <Icon className="ficon-plus" />
    </ToolbarButton>
    <ToolbarButton
      onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete })}
      disabled={selected.length === 0}
      ariaLabel="Delete Selected"
      tooltipContent="Delete Selected">
      <Icon className="ficon-trash-2" />
    </ToolbarButton>
  </ToolbarWrapper>;
}

export default React.memo(ToolbarComponent);
